if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.hero');
      this.autoplaySpeed = Number(this.getAttribute('autoplay-speed')) * 1000;
    }

    connectedCallback() {
      if (this.slides.length > 1) {
        this.initSlider();
      }
    }

    initSlider() {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: this.autoplaySpeed,
        pauseOnHover: false,
        pauseOnFocus: false,
      });
    }
  }
  customElements.define('hero-slider', HeroSlider);
}
